import React, { useEffect } from 'react';

import MainLayout from '../../components/layout/Main';
import FeatureIntro from '../../components/organisms/featureIntro';
import usePageTitle from '../../hooks/usePageTitle';
import { MainLayoutHeader } from '../../components/atoms/mainLayoutHeader';
import { useTierGating } from '../../hooks/useTierGating';
import { useUpsellTracking } from '../../hooks/useUpsellTracking';
import FeatureIframe from '../../components/organisms/featureIframe';
import PeopleFinderImage from '../../assets/feature-intro-people-finder.png';
import PeopleFinderTestimonialAvatar from '../../assets/feature-intro-people-finder-testimonial-avatar.png';

export const Projects = () => {
  usePageTitle('People Finder');
  const { hasCapability } = useTierGating();
  const { trackPaywallShown } = useUpsellTracking();
  const hasAccess = hasCapability('people_finder');

  useEffect(() => {
    if (!hasAccess) {
      trackPaywallShown('people_finder');
    }
  }, [hasAccess, trackPaywallShown]);

  if (!hasAccess) {
    return (
      <MainLayout containerProps={{ pb: 0, minHeight: '100vh' }}>
        <MainLayoutHeader title="People Finder" />
        <FeatureIntro
          featureName="People Finder"
          title="Find the right people, beyond your network"
          description="Search across 850+ million enriched profiles to find candidates, experts, investors, or buyers from outside your existing network."
          features={[
            'Trust search results with 3D data and success/relationship signals',
            'Get prioritized lists of profiles that match your criteria with Copilot',
            'Keep your data fresh with automated syncs and updates',
          ]}
          image={PeopleFinderImage}
          imageAlt="People Finder feature preview"
          ctaText="Get People Finder today"
          footerNote="Find the people that make the difference to your community"
          testimonial={{
            avatarSrc: PeopleFinderTestimonialAvatar,
            quote:
              'I can create unique, highly targeted, and data-driven searches that aren\u2019t possible using any other platform or tool.',
            author: 'PSRP KIRAN',
            role: 'Senior Manager of Recruitment, Adobe',
          }}
        />
      </MainLayout>
    );
  }

  return <FeatureIframe featureKey="projects" title="Findem Projects" />;
};
